<template>
<div class="chapter">
<div class="inner_page">
<p class="imagel"><a id="ch007"></a><a id="page_22"></a><img alt="Image" src="images/f0022-01.jpg" width="450px"/></p>
<p class="indent">“COMMANDER WILLIAM T. RIKER (played by Jonathan Frakes): Number One (whom the U.S. Navy would call the ‘Executive Officer’) is in his early thirties, considered by Starfleet to be a top quality captain-in-training. His principal responsibilities are:</p>
<p class="indent">“1. to constantly provide the Captain with a top condition vessel and crew, and,</p>
<p class="indent">“2. to command away missions.</p>
<p class="indent">“Like all First Officers, Riker feels highly possessive about the <em>Enterprise</em>—considers it <em>his</em> ship, quite understandably since he is the one responsible for keeping the vessel polished and efficient. (From time immemorial First Officers have considered the ship captain as one who merely <em>uses</em> the vessel.) This creates no friction between Picard and Riker since, after all, Picard was the same kind of proud First Officer before becoming a Captain….</p>
<p class="indent">“One of Riker’s special charms (shared also by the actor) is the ‘twinkle’ in his eye which suggests a very special sense of humor.</p>
<p class="indent">“Riker is called ‘Number One’ by the Captain. Only rarely is he called that by an <em>Enterprise</em> crewmember, and never by anyone not part of the <em>Enterprise</em>. Socially, his friends call him <em>Will</em>.</p>
<p class="indent">“Riker was born in Valdez, Alaska, and there is a strong outdoors pioneer quality in his personality…. Like the legendary 23rd century Kirk (when in his early thirties), our Number One is very strong and agile and has a tendency toward ‘derring-do.’ Also like Captain Kirk, Riker has a healthy sex drive.”</p>
<p class="indent">—from the <em>Star Trek: The Next Generation</em> writers’/directors’ guide ’88–89, second-season revision</p>
<p class="image"><a id="page_23"></a><img alt="Image" src="images/f0023-01.jpg" width="450px"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?4472e3bd